import { Box, colors, Stack, Typography } from '@mui/material';
import React, { useContext } from 'react';
import theme from 'theme';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
import { useNavigate } from 'react-router';
import UserContext from 'state/UserContext';

const AccessDenied = () => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  return (
    <Stack
      style={{
        padding: '2rem',
        margin: '1rem',
        boxShadow: theme.shadows[3],
        display: 'flex',
        flexDirection: 'row',
        borderRadius: '1rem',
        backgroundColor: '#fff',
      }}>
      <Box
        sx={{
          backgroundColor: colors.grey[200],
          borderRadius: '50%',
          padding: '1rem',
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          marginRight: '1rem',
        }}>
        <DiamondOutlinedIcon
          sx={{
            fontSize: '4.5rem',
            color: '#546e7a',
          }}
        />
      </Box>
      <Box>
        <Typography
          sx={{
            fontSize: '1.8rem',
            fontWeight: 'bolder',
            color: '#546e7a',
          }}>
          RESTORIZE PRO FEATURE!
        </Typography>

        <Typography variant="body1">
          This feature is not active for your organization at the moment.
        </Typography>
        <Typography variant="body2">
          Please{' '}
          <span>
            {user.role === 'Administrator' ? (
              <span
                style={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  color: theme.palette.primary.main,
                }}
                onClick={() => navigate('/contact-support')}>
                contact our support team
              </span>
            ) : (
              'contact your administrator'
            )}
          </span>{' '}
          for more information.
        </Typography>
      </Box>
    </Stack>
  );
};

export default AccessDenied;
